// CommonJS format instead of ES6 modules
const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
const APP_KEY = "";

// Welcome message configuration
const configs = {
    // Default welcome message
    default: {
        serverPath: 'cangnan.chat-notary.com/api',
        title: '浙江省苍南县公证处',
        subtitle: '您好！我是浙江省苍南县公证处的智能咨询小助手“小苍”，为您提供 7×24 小时公证服务。凭借对公证知识、法律法规和实践案例的深入学习，我作为人工智能智能体（AI Agent），可以处理各类公证相关咨询。我正处于不断学习的阶段，但保证会全力以赴为您提供最优解。请问，我该如何为您提供协助呢？',
        clientId: 'cangnan',
        avatar: 'https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1942556148986959424/2026495579463014592/image/tpSJsdQjkwcqcLqDPve-2026495579827919040.png',
        bgEnabled: true,
        defaultQuestions: [
            '浙江省苍南县公证处可以办理哪些业务？',
            '哪些业务可以在线办理？',
            '怎么通过线上申请办理公证？'
        ],
        quickLinks: null,
        questionTree: null
    },
    local: {
        serverPath: 'cangnan.chat-notary.com/api',
        title: '浙江省苍南县公证处',
        subtitle: '您好！我是浙江省苍南县公证处的智能咨询小助手“小苍”，为您提供 7×24 小时公证服务。凭借对公证知识、法律法规和实践案例的深入学习，我作为人工智能智能体（AI Agent），可以处理各类公证相关咨询。我正处于不断学习的阶段，但保证会全力以赴为您提供最优解。请问，我该如何为您提供协助呢？',
        clientId: 'cangnan',
        avatar: 'https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1942556148986959424/2026495579463014592/image/tpSJsdQjkwcqcLqDPve-2026495579827919040.png',
        bgEnabled: true,
        defaultQuestions: [
            '浙江省苍南县公证处可以办理哪些业务？',
            '哪些业务可以在线办理？',
            '怎么通过线上申请办理公证？'
        ],
        quickLinks: null,
        questionTree: null
    }
};

function getSubdomain() {
    // if localhost, return local
    if (window.location.hostname === 'localhost') {
        return 'local';
    }
    const hostnameParts = window.location.hostname.split('.');
    // Assumes structure is subdomain.domain.tld or subdomain.app.domain.tld
    // If your domain structure is different, adjust this logic.
    if (hostnameParts.length > 2) {
        return hostnameParts[0];
    }
    return 'default'; // Or whatever your main app's identifier is
}

const subdomain = typeof window !== 'undefined' ? getSubdomain() : 'default';

// Export the configuration for the current subdomain, or the default
const config = configs[subdomain] || configs.default;
// CommonJS exports instead of ES6 exports
module.exports = {
    ACCESS_TYPE,
    APP_KEY,
    config
};



// WEBPACK FOOTER //
// ./src/constants/static.js